import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { BiGridSmall } from "react-icons/bi";
import mixpanel from "mixpanel-browser";

import { TiTick } from "react-icons/ti";
import { firebase } from "../../../firebase/config";
import MobileFooter from "../Layout/mobileFooter";

import MobileTopMenu from "../Layout/mobileTopMenu";

class AboutMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      price: "",
      clinicName: "",
      isNavbar: true,
      signUp: false,
      error: "",
      display: "none",
      buttonActive: true,
      Email: "",
      Password: "",
      isChecked: false,
      Type: "",
    };

    this.openModal = this.openModal.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmitEmail = this.onSubmitEmail.bind(this);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  openModal = () => {
    this.setState({ signUp: true, isNavbar: false });
    document.body.style.overflow = "hidden";
  };

  onSubmitEmail = (event) => {
    if (!this.state.Email || !this.state.Password || !this.state.Type) {
      return this.setState({ error: "Missing information" });
    } else if (!this.state.isChecked) {
      return this.setState({ error: "Make sure to tick the box" });
    } else {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.state.Email, this.state.Password)
        .then((userCredential) => {
          const uid = userCredential.user.uid;
          firebase.firestore().collection("user").doc(uid).set({
            email: userCredential.user.email,
            id: uid,
            Type: this.state.Type,
          });
        })
        .then(() => {
          firebase
            .firestore()
            .collection("messages")
            .add({
              to: "+447507435922",
              body: `${this.state.Email} signed up as a ${this.state.Type}`,
            });
          this.setState({ error: null });
          this.props.history.push("/success");
        })
        .catch((error) => {
          this.setState({ error: error.message });
        });
    }

    event.preventDefault();
  };

  componentDidMount() {}

  render() {
    return (
      <>
        <div
          style={{
            width: "100vw",
            backgroundColor: "white",
            color: "black",
            overflowX: "hidden",
          }}
        >
          <MDBRow style={{ marginTop: 0, paddingBottom: 0 }}>
            <MobileTopMenu color="light" />
            <MDBRow>
              <MDBCol size="12">
                <MDBRow style={{ height: "50vh" }}>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        fontSize: 16,
                        marginTop: 90,
                        textAlign: "center",
                        opacity: 1,
                        color: "#FF0000",
                      }}
                    >
                      OUR MISSION
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSExtraBold",
                        fontSize: 28,
                        marginTop: -5,
                        lineHeight: 1.3,
                        width: "90%",
                        textAlign: "center",
                      }}
                    >
                      We're on a mission to help
                      <br />
                      creators and platforms grow
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        opacity: 0.7,
                        fontSize: 15,
                        width: "85%",
                        marginTop: 0,
                        textAlign: "center",
                        opacity: 0.7,
                      }}
                    >
                      We believe in empowering creators like you. By making it
                      cheap and easy to localise your content, we can help you
                      grow your audience faster. Chat with us today and see if
                      we can help.
                    </p>
                  </MDBCol>

                  <MDBCol className="d-flex justify-content-center" size="12">
                    <a
                      href=""
                      target="_blank"
                      className="d-flex justify-content-center"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <div
                        className="d-flex HeroButton lightButton justify-content-center"
                        style={{
                          borderRadius: 200,
                          paddingTop: 10,
                          color: "white",
                          fontFamily: "PlusJSBold",
                          fontSize: 17,
                          width: 170,
                          height: 49,
                          marginTop: 10,
                          display: "inline-block",
                        }}
                      >
                        Book a Demo
                      </div>
                    </a>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        fontSize: 12,
                        marginTop: 5,
                        textAlign: "center",
                        opacity: 1,
                      }}
                    >
                      Have questions?{" "}
                      <a
                        href="mailto:help@youdub.me"
                        style={{
                          display: "inline-block",
                          textDecoration: "underline",
                          color: "#FF0000",
                        }}
                      >
                        Contact us
                      </a>
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol
                className="d-flex justify-content-center"
                size="12"
              ></MDBCol>
            </MDBRow>
          </MDBRow>

          <MDBRow
            style={{
              paddingBottom: "5vh",
              backgroundColor: "#F5F5F5",
              color: "black",
              width: "105vw",
              paddingLeft: "8%",
              marginTop: 100,
            }}
          >
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  fontSize: 13,
                  marginTop: 70,
                  opacity: 1,
                  color: "#FF0000",
                }}
              >
                OUR STORY
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 29,
                  marginTop: -5,
                  lineHeight: 1.3,
                  width: "100%",
                }}
              >
                It all started in 2023...
              </p>
            </MDBCol>
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 15,
                  width: "99%",
                  marginTop: 0,
                  opacity: 0.7,
                }}
              >
                Our journey with YouDub began when we encountered the challenges
                of dubbing content for YouTube channels. We realized the
                time-consuming and labor-intensive nature of manual dubbing
                processes, which hindered content creators from reaching broader
                international audiences. To address this pain point, we
                developed YouDub, a cutting-edge platform for automated dubbing.
                <br />
                <br />
                YouDub revolutionizes the dubbing process by leveraging advanced
                AI technology. Our platform analyzes the audio content of
                YouTube videos, transcribes it, and generates accurate
                translations in real-time. These translations are then
                synchronized with the original video, resulting in high-quality
                dubbed versions that resonate with diverse language-speaking
                audiences.
                <br />
                <br />
                Content creators using YouDub gain several benefits. Firstly, it
                eliminates the need for manual translation and recording, saving
                substantial time and resources. Secondly, YouDub provides an
                opportunity to expand viewership and monetization potential by
                catering to international markets. By automatically dubbing
                their videos into different languages, content creators can
                engage a global audience and increase their YouTube channel's
                growth.
                <br />
                <br />
                YouDub supports multiple languages and accents, ensuring
                localized and authentic dubbing experiences. Our platform
                continually improves its accuracy and quality through machine
                learning algorithms and user feedback. You can rely on YouDub to
                deliver accurate and professional dubbing results that align
                with your channel's objectives.
                <br />
                <br />
                To get started with YouDub, sign up for a trial period and
                experience the capabilities of our platform. We offer flexible
                pricing plans tailored to the volume and duration of videos you
                process. Our dedicated support team is available to assist you
                throughout the onboarding process, ensuring a smooth integration
                into your workflow.
              </p>
            </MDBCol>
          </MDBRow>

          <MDBRow style={{ paddingLeft: "5%" }}>
            <div
              className="pattern2"
              style={{
                height: 400,
                width: "105vw",
                backgroundRepeat: "repeat",
              }}
            >
              <MDBRow>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSExtraBold",
                      fontSize: 29,
                      color: "black",
                      marginTop: 100,
                      lineHeight: 1.3,
                      width: "70%",
                      textAlign: "center",
                    }}
                  >
                    Excited to join our mission?
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      opacity: 0.7,
                      fontSize: 16,
                      width: "85%",
                      marginTop: 0,
                      textAlign: "center",
                      opacity: 0.7,
                    }}
                  >
                    We're assembling a team of wonderful people that love
                    solving hard problems and working together.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <a
                    href=""
                    target="_blank"
                    className="d-flex justify-content-center"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex HeroButton lightButton justify-content-center"
                      style={{
                        borderRadius: 200,
                        paddingTop: 10,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 190,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      See open roles
                    </div>
                  </a>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        color: "#FF0000",
                        textDecoration: "underline",
                      }}
                    >
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>
        </div>
        <MobileFooter
          executeScroll1={this.executeScroll1}
          executeScroll2={this.executeScroll2}
          executeScroll3={this.executeScroll3}
          executeScroll4={this.executeScroll4}
        />
      </>
    );
  }
}

export default withRouter(AboutMobile);
